// Offline nutrient atlas data + benefit logic (bundled JSON in /public/data, zero cloud cost).
export const PILLAR = { fuel: '#5BE08A', power: '#FF6478', force: '#5DD4FF', energy: '#B978FF', aegis: '#FFB265', destiny: '#7C9BFF' };

export const NUT_GROUP = {
  kcal: 'power', pro: 'power', carb: 'power', fat: 'power', fib: 'power', sug: 'power',
  o3: 'destiny', cho: 'destiny',
  vB1: 'energy', vB2: 'energy', vB3: 'energy', vB5: 'energy', vB6: 'energy', vB9: 'energy', vB12: 'energy', vC: 'energy',
  vA: 'aegis', vD: 'aegis', vE: 'aegis', vK: 'aegis',
  Ca: 'force', Mg: 'force', P: 'force', K: 'force', Na: 'force',
  Fe: 'fuel', Zn: 'fuel', Cu: 'fuel', Mn: 'fuel', Se: 'fuel',
};

export const BENEFITS = [
  { id: 'immunity', label: 'Immunity Shield', keys: ['vC', 'Zn', 'vA', 'Se', 'vD'] },
  { id: 'bone', label: 'Bone Strength', keys: ['Ca', 'vD', 'vK', 'Mg', 'P'] },
  { id: 'blood', label: 'Blood & Iron', keys: ['Fe', 'vB12', 'vB9', 'Cu'] },
  { id: 'skin', label: 'Glowing Skin', keys: ['vC', 'vE', 'vA', 'Zn', 'o3'] },
  { id: 'hair', label: 'Hair Growth', keys: ['pro', 'Fe', 'Zn', 'vB12', 'Se'] },
  { id: 'eyes', label: 'Eye Vision', keys: ['vA', 'Zn', 'vE'] },
  { id: 'heart', label: 'Heart Health', keys: ['o3', 'fib', 'K', 'Mg'] },
  { id: 'gut', label: 'Gut & Digestion', keys: ['fib'] },
  { id: 'muscle', label: 'Muscle Build', keys: ['pro', 'K', 'Mg'] },
  { id: 'brain', label: 'Brain & Focus', keys: ['o3', 'vB6', 'vB12', 'cho', 'vB9'] },
  { id: 'energy', label: 'Energy & Metabolism', keys: ['vB1', 'vB2', 'vB3', 'vB5', 'vB6', 'Fe'] },
  { id: 'bp', label: 'Blood Pressure', keys: ['K', 'Mg', 'Ca'] },
  { id: 'antiox', label: 'Antioxidant Defence', keys: ['vC', 'vE', 'Se', 'Mn'] },
  { id: 'preg', label: 'Pregnancy Support', keys: ['vB9', 'Fe', 'cho', 'Ca'] },
  { id: 'heal', label: 'Healing & Clotting', keys: ['vK', 'vC', 'Zn'] },
  { id: 'calm', label: 'Calm & Sleep', keys: ['Mg', 'vB6'] },
  { id: 'thyroid', label: 'Thyroid Support', keys: ['Se', 'Zn'] },
  { id: 'lean', label: 'Weight Friendly', keys: ['fib', 'pro'], lean: true },
];

const richMin = (key) => (key === 'fib' ? 10 : 20);

let cache = null;
export const loadAtlas = async () => {
  if (cache) return cache;
  const res = await fetch(`${process.env.PUBLIC_URL || ''}/data/nutrients.json`);
  const raw = await res.json();
  const nutrients = raw.nutrients.map(([key, label, unit, dv]) => ({ key, label, unit, dv, color: PILLAR[NUT_GROUP[key]] }));
  const idx = Object.fromEntries(nutrients.map((n, i) => [n.key, i]));
  const foods = raw.foods.map(([name, g, ...vals], id) => {
    const pct = nutrients.map((n, i) => (n.dv ? (vals[i] / n.dv) * 100 : 0));
    const rich = new Set(nutrients.filter((n, i) => n.dv && pct[i] >= richMin(n.key)).map((n) => n.key));
    const benefits = BENEFITS.filter((b) => (b.lean ? vals[idx.kcal] <= 60 && vals[idx.kcal] > 0 && (rich.has('fib') || vals[idx.pro] >= 4) : b.keys.some((k) => rich.has(k))))
      .map((b) => ({ id: b.id, score: b.keys.reduce((s, k) => s + (rich.has(k) ? Math.min(pct[idx[k]], 150) : 0), 0) + (b.lean ? 60 - vals[idx.kcal] : 0) }));
    return { id, name, lower: name.toLowerCase(), group: raw.groups[g], vals, pct, rich, benefits };
  });
  cache = { nutrients, idx, foods, groups: raw.groups };
  return cache;
};

export const fmt = (v) => (v >= 100 ? Math.round(v) : v >= 10 ? v.toFixed(1) : v.toFixed(2).replace(/\.?0+$/, '') || '0');
